<template>
	<section>
		<div class="d-sm-flex align-items-center justify-content-between mb-4">
	        <h1 class="h3 mb-0 text-gray-800">Dashboard</h1>

	        <div v-if="btn_refresh_dsb" @click="start_timestamps" class="col-auto">
	            <small class="vermelho">A atualização automatica do Dashboard foi temporariamente desabilitada.</small>
	            <button class="btn btn-primary btn-sm ml-2">Ativar</button>
	        </div>

	        <div class="col-md-2">
	            <input type="date" v-if="form_date" class="form-control form-control-sm" @change="filter_date" v-model="date">
	        </div>
	    </div>

		<ul class="nav nav-tabs" role="tablist" style="margin-bottom: 5px;">
	        <li class="nav-item">
	        	<router-link :to="{name: 'dsb_Charts', params: {get: 'Graficos'} }" class="nav-link active" data-toggle="tab">Graficos</router-link>
	        </li>

	        <li class="nav-item" @click="start_timestamps" >
	        	<router-link :to="{name: 'dsb_Ramais', params: {get: 'Ramais'} }" class="nav-link" data-toggle="tab">Ramais</router-link>
	        </li>
	    </ul>

	    <div class="row">
	        <div class="col-12">
	            <div class="tab-content">
	            	<transition mode="out-in" name="leftIn">
						<router-view :key="get" :form_date.sync="form_date" ref="page_tab"></router-view>
					</transition>
	            </div>
	        </div>
	    </div>
	</section>
</template>

<script>
	export default {
		props: ["get"],

		data() { 
			return {
				form_date: false,
				date: null,
				stoped: false
			}
		},

		computed: {
			btn_refresh_dsb() {
				return (this.stoped && this.form_date) ? true : false
			}
		},

		methods: {
			filter_date() {
				this.$refs.page_tab.get_to_date(this.date);
				this.$refs.page_tab.teste = false;
				this.stoped = true;
			},

			start_timestamps() {
				this.stoped = false;
				this.date = null;
				//this.$refs.page_tab.start_timestamps()
			}
		},

		beforeRouteLeave (to, from, next) {
			this.filter_date();
			next();
		},

	}
</script>

<style>
	
</style>